module.exports = __webpack_public_path__ + "img/microplastics-5-mobile.f6b6d994.png";